module.exports = "<p>\r\n    root works!\r\n</p>"


//////////////////
// WEBPACK FOOTER
// D:/Development/angular-hybrid-lazy-load-example/src/app/root/root.component.html
// module id = ../../../../../src/app/root/root.component.html
// module chunks = main